module.exports = __webpack_public_path__ + "img/yssj.10b83e1c.png";